import { useState, useContext, createContext, useEffect, useCallback } from 'react';
import { useParams } from 'react-router-dom';
import ObjectId from "bson-objectid";

const FORMS_CLIPBOARD_STORAGE_KEY = 'FORMS_CLIPBOARD';
const MAX_STORAGE = 10;

const FormsClipboardContext = createContext({});

export function FormsClipboardProvider({ children }) {
    const [items, setItems] = useState([]);
    const { id: deploymentId } = useParams();

    useEffect(() => {
        const currentItems = sessionStorage.getItem(`${FORMS_CLIPBOARD_STORAGE_KEY}_${deploymentId}`);
        if (currentItems) {
            try {
                setItems(JSON.parse(currentItems));
            } catch (error) {
                console.error(
                    `Error retrieving form clipboard items from storage: ${error.message}`
                );
            }
        }
    }, [deploymentId]);

    const addItem = useCallback((newItem) => {
        setItems((currentItems) => {
            const itemsFromIndex = Math.max(currentItems.length - MAX_STORAGE + 1, 0);
            const result = [...currentItems.slice(itemsFromIndex), { ...newItem, _id: new ObjectId().toHexString() }];

            sessionStorage.setItem(`${FORMS_CLIPBOARD_STORAGE_KEY}_${deploymentId}`, JSON.stringify(result));

            return result;
        });

        return { location: 'clipboard' };
    }, [deploymentId]);

    return (
        <FormsClipboardContext.Provider
            value={{
                items,
                addItem
            }}
        >
            {children}
        </FormsClipboardContext.Provider>
    );
}

export function useFormsClipboard() {
    return useContext(FormsClipboardContext);
}
